"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardDialog = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("../Dialog"));
const DialogSize_1 = __importDefault(require("../Dialog/DialogSize"));
const makeMyClasses = () => ({
    stepper: {
        justifyContent: 'flex-end',
    },
});
function WizardDialog(props) {
    const { title, steps, allowNext, padded = true, closable = true, skipButton, initialStep = 0, hideStepNumbers = false, additionalButtons, onClose, getOkLabel, size = DialogSize_1.default.X450_Y250, validate, onComplete, } = props;
    const [activeStep, setActiveStep] = (0, react_1.useState)(initialStep);
    const [completing, setCompleting] = (0, react_1.useState)(false);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const { goBack } = (0, useNav_1.default)();
    const allowed = allowNext ? allowNext(activeStep) : true;
    const handleBack = (0, react_1.useCallback)(() => {
        setActiveStep(Math.max(activeStep - 1, initialStep));
    }, [activeStep, initialStep]);
    const handleNext = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (!validate || (yield validate(activeStep))) {
            setActiveStep(Math.min(activeStep + 1, steps.length - 1));
        }
    }), [activeStep, steps.length, validate]);
    const handleComplete = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (!validate || (yield validate(activeStep))) {
            setCompleting(true);
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                yield onComplete();
                setCompleting(false);
            }), 0);
        }
        if (!onComplete) {
            goBack();
        }
    }), [activeStep, goBack, onComplete, validate]);
    const handleClose = (0, react_1.useCallback)(() => {
        !!onClose ? onClose() : goBack();
    }, [goBack, onClose]);
    const childrenRightOfTitle = (0, react_1.useMemo)(() => {
        if (!(steps.length > 1 && !hideStepNumbers))
            return null;
        return (react_1.default.createElement(core_1.Stepper, { activeStep: activeStep, className: myCss.stepper }, steps.map((step, index) => (react_1.default.createElement(core_1.Step, { key: index },
            react_1.default.createElement(core_1.StepLabel, null))))));
    }, [activeStep, hideStepNumbers, myCss.stepper, steps]);
    const buttonsLeft = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(Horizontal_1.default, { gutter: true },
            activeStep > initialStep && (react_1.default.createElement(Button_1.default, { disabled: completing, onClick: handleBack, color: lib_palette_1.default.Grey, label: lib_i18n_1.default.t('back') })),
            !closable && (react_1.default.createElement(Button_1.default, { onClick: handleClose, color: lib_palette_1.default.Grey, label: lib_i18n_1.default.t('cancel') }))));
    }, [activeStep, closable, completing, handleBack, handleClose, initialStep]);
    const buttonsRight = (0, react_1.useMemo)(() => {
        const addBut = additionalButtons === null || additionalButtons === void 0 ? void 0 : additionalButtons(activeStep);
        const skipBut = skipButton === null || skipButton === void 0 ? void 0 : skipButton(activeStep);
        const butLabel = getOkLabel
            ? getOkLabel(activeStep)
            : activeStep < steps.length - 1
                ? lib_i18n_1.default.t('next')
                : lib_i18n_1.default.t('done');
        return (react_1.default.createElement(Horizontal_1.default, { gutter: true },
            addBut,
            !!skipBut && react_1.default.createElement(Button_1.default, { onClick: skipBut, label: lib_i18n_1.default.t('skip') }),
            react_1.default.createElement(Button_1.default, { onClick: activeStep < steps.length - 1 ? handleNext : handleComplete, disabled: completing || !allowed, label: butLabel })));
    }, [
        activeStep,
        additionalButtons,
        allowed,
        completing,
        getOkLabel,
        handleComplete,
        handleNext,
        skipButton,
        steps,
    ]);
    return (react_1.default.createElement(Dialog_1.default, { size: size, title: title, padded: padded, childrenRightOfTitle: childrenRightOfTitle, buttonsLeft: buttonsLeft, buttonsRight: buttonsRight, closable: closable, onClose: onClose }, steps[activeStep]));
}
exports.WizardDialog = WizardDialog;
exports.default = WizardDialog;
